import { render, staticRenderFns } from "./category.vue?vue&type=template&id=55039fbe&scoped=true&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"
import style0 from "./category.vue?vue&type=style&index=0&id=55039fbe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55039fbe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WareView: require('/app/components/ware-view/index.vue').default})
